module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/b9cee2084d375a200f58afe4e2c36438.png";